import { IQuoteRespSchema } from '@monetize/types/app';
import { MFlex, MLink, MText } from '../../../../../../components/Monetize';
import { QuoteDownloadMenu } from '../../../../../../components/Quotes/QuoteDownloadMenu';
import { useIsTenantEsignConfigured } from '../../../../../../hooks/useIsTenantEsignConfigured';

export const SendQuoteManuallyContent = ({
  quote,
}: {
  quote: IQuoteRespSchema;
}) => {
  const isTenantEsignConfigured = useIsTenantEsignConfigured();

  return (
    <MFlex flexDir="column" justify="center" align="start" gap="4">
      <MText fontWeight="normal">
        {`Clicking 'Confirm' indicates that you have sent this Quote to the customer.`}
      </MText>
      {!isTenantEsignConfigured && (
        <MFlex flexDir="column" color="tGray.darkPurple">
          <MText fontWeight="semibold">Did you know?</MText>
          <MText>
            MonetizeNow can automate signature gathering. To set it up, send
            your Administrator to our{' '}
            <MLink
              href="https://docs.monetizenow.io/docs/setting-up-esign"
              target="_blank"
            >
              documentation
            </MLink>{' '}
            or have them reach out to{' '}
            <MLink
              href="mailto:support@monetizenow.io"
              target="_blank"
              textDecoration="underline"
            >
              support@monetizenow.io
            </MLink>
            .
          </MText>
        </MFlex>
      )}
      {isTenantEsignConfigured && !quote.requiresEsign && (
        <MText>
          {`This Quote can be sent automatically with eSign.  To do so, click 'Cancel', then 'Edit Quote', and turn on eSign for this Quote.`}
        </MText>
      )}
      <QuoteDownloadMenu quote={quote} />
    </MFlex>
  );
};
